module.exports = __webpack_public_path__ + "img/bottom.f37b55ef.svg";